import { call, put, select, takeEvery } from 'redux-saga/effects'
import { SplashScreenApi } from '../../api/SplashScreen'
import { SplashScreenResult } from '../../api/SplashScreen/types'
import { isOfflineError } from '../../services/errorManager'
import { splashScreenRefresh } from '../../services/splashScreen'
import { SplashScreenActions } from './actions'
import { splashScreenUrlSelector } from './selector'
import { SplashScreenActionTypes } from './types'

function* loadSplashScreenSaga() {
  try {
    const result: SplashScreenResult = yield call(SplashScreenApi.load)
    const cachedUrl: string | null = yield select(splashScreenUrlSelector)
    switch (splashScreenRefresh(result?.splashscreen, cachedUrl)) {
      case 'download':
        yield put(SplashScreenActions.storePendingSplashScreen(result.splashscreen as string))
        break
      case 'clear':
        yield put(SplashScreenActions.clearSplashScreen())
        break
      default:
        break
    }
  } catch (error) {
    if (!isOfflineError(error as Error)) {
      console.error('ERROR =', error)
    }
  }
}

export function* loadSplashScreenWatcher() {
  yield takeEvery(SplashScreenActionTypes.LOAD_SPLASH_SCREEN, loadSplashScreenSaga)
}
